import * as React from 'react';
import { useEffect } from 'react';
import Top from "../Top";
import Bottom from "../Bottom";
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Container from '@mui/material/Container';

import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Chip from '@mui/material/Chip';
import Divider from '@mui/material/Divider';
import Fab from '@mui/material/Fab';

import DehazeIcon from '@mui/icons-material/Dehaze';
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
import FlatwareIcon from '@mui/icons-material/Flatware';
import HealthAndSafetyIcon from '@mui/icons-material/HealthAndSafety';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CheckIcon from '@mui/icons-material/Check';
import CreateIcon from '@mui/icons-material/Create';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import FeedbackIcon from '@mui/icons-material/Feedback';
import InsertCommentIcon from '@mui/icons-material/InsertComment';

import * as util from "../../utils/util";
import api from "../../utils/api_v2";
import LodingData from "../../utils/LodingData";


import tab04 from "../../assets/images/tab_01.png"
import { colors, Dialog, DialogActions, DialogContent, DialogTitle, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from '@mui/material';
import Pagination from 'react-js-pagination';

const counsel = {
  id: '',
  title: '',
  content: '',
  createDate: '',
  answer: '',
  type: '',
  category: '',
  answerDate: '',
  memberId: ''
}

const Counsel = () => {

  const navigate = useNavigate();
  const [alignment, setAlignment] = React.useState('all');
  const [expandedAccordions, setExpandedAccordions] = React.useState([10000000]);
  const [counselList, setCounselList] = React.useState([counsel]);
  const [counselListParam, setCounselListParam] = React.useState({ cusId: localStorage.getItem('userCusID'), pagingNum: 0 });
  const [counselListCount, setCounselListCount] = React.useState(0);
  const [counselType, setCounselType] = React.useState('MY');

  const [boardInfo, setBoardInfo]: any = React.useState<Record<string, any>>({});

  // 모달창
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setTimeout(() => setOpen(true), 100);
  const handleClose = () => setOpen(false);

  let cnt = counselListParam.pagingNum * 10;

  useEffect(() => {
    // if (util.strNull(window.localStorage.userCusID) !== '') {
    //   getCounselList('MY', '');
    // }
    getCounselList();

    return () => {
      setCounselListParam({ cusId: localStorage.getItem('userCusID'), pagingNum: 0 });
    }
  }, []);

  const handleAlignment = (
    event: React.MouseEvent<HTMLElement>,
    newAlignment: string | null,
  ) => {
    if (newAlignment !== null) {
      setAlignment(newAlignment);
    }
  };

  const accordionClicked = (index: any) => {
    if (expandedAccordions.includes(index))
      setExpandedAccordions(
        expandedAccordions.filter((number) => number !== index)
      );
    else setExpandedAccordions([...expandedAccordions, index]);
  };

  const collapseAll = () => {
    setExpandedAccordions([]);
  };

  function getCounselList() {
    collapseAll();  // 아코디언 모두 접기
    // setCounselType(type); // [전체상담, 내 상담] 탭 구분
    // if (counselType !== type) {  // [전체상담, 내 상담] 탭 변경 시, 하위 카테고리 [전체] 초기화
    //   setAlignment('all');
    // }
    // api.get(`app/api/v1/AP_003_001?type=${type}&category=${category}`).then(res => {
    //   setCounselList(res.data.result_data.support_list);
    // }).catch(function (error) {
    //   console.log(error)
    // });
    // console.log(counselListParam);
    LodingData(() => api.post('customer/api/v1/CU_008_001', counselListParam)
      .then(res => {
        // console.log(res);
        setCounselList(res.data.qnADTOList);
        setCounselListCount(res.data.count);
      })
      .catch(err => {
        console.log(err);
      }))

  }

  function getCategoryChipComponent(category: any) {
    if (category === 'EXERCISE') {
      return <Chip icon={<FitnessCenterIcon />} label="운동" color="primary" size="small" />;
    } else if (category === 'HEALTH') {
      return <Chip icon={<HealthAndSafetyIcon />} label="건강" color="secondary" size="small" />;
    } else if (category === 'DIET') {
      return <Chip icon={<FlatwareIcon />} label="식이" color="info" size="small" />;
    }
  }

  function handlePageChange(page: number) {
    setCounselListParam({ cusId: localStorage.getItem('userCusID'), pagingNum: page - 1 });
    getCounselList();
  }

  // 1개 항목 클릭 시 게시글 번호 받아 글 상세내용 보내기
  const handleSelectRow = (targetRow: any) => {
    LodingData(() => api.post('customer/api/v1/CU_008_003', { qnaId: targetRow.qnaId })
      .then(res => {
        // console.log(res);
        res.data.status = res.data.status == true ? '답변완료' : '답변대기중';
        res.data.helper = res.data.answer == '' ? '답변대기중' : '관리자';
        setBoardInfo(res.data);
      })
      .catch(function (error) {
        console.log(error);
      }));
  }

  return (
    <Container className="container">
      <Box sx={img} >
        <Grid container spacing={2} direction='row' justifyContent='center' alignItems={'center'} sx={{ overflow: 'hidden', height: 200, textAlign: 'center' }}>
          <Grid item container xs sx={{ pl: 0 }} direction='column' justifyContent='center'>
            <Typography className='topText' sx={{ fontSize: '2.2rem', color: '#8acd83', fontWeight: 900 }}>
              고객센터
            </Typography>
            <Typography sx={{ fontSize: '1.8rem', color: '#5ead3d', fontWeight: 500, }} gutterBottom>
              내 문의 내역
            </Typography>
          </Grid>
        </Grid>
      </Box>

      {/* <Stack direction="row" justifyContent="center" alignItems="center" spacing={0} sx={{ mt: 1, bgcolor: '#ffb068', borderRadius: '20px' }}>
        <CareButton variant="contained" sx={counselType === 'ALL' ? {} : { bgcolor: '#FFB068', color: '#fff' }}
          onClick={() => {
            getCounselList('ALL', '')
          }}
        >
          전체상담
        </CareButton>
        <CareButton variant="contained" sx={counselType === 'MY' ? {} : { bgcolor: '#FFB068', color: '#fff' }}
          onClick={() => {
            getCounselList('MY', '')
          }}
        >
          내 상담
        </CareButton>
      </Stack> */}

      {/* <Stack direction="row" spacing={0} sx={{ mt: 3, width: '80%', mr: 'auto', ml: 'auto', }}>
        <ToggleButtonGroup
          value={alignment}
          exclusive
          onChange={handleAlignment}
          aria-label="text alignment"
          sx={{ width: '100%', bgcolor: '#fff' }}
        >

          <ToggleButton value="all" aria-label="all" sx={toggleBtn} onClick={() => getCounselList(counselType, '')}>
            <DehazeIcon fontSize='small' />
            <Typography>전체</Typography>
          </ToggleButton>
          <ToggleButton value="active" aria-label="active" sx={toggleBtn} onClick={() => getCounselList(counselType, 'EXERCISE')}>
            <FitnessCenterIcon fontSize='small' />
            <Typography>운동</Typography>
          </ToggleButton>
          <ToggleButton value="health" aria-label="health" sx={toggleBtn} onClick={() => getCounselList(counselType, 'HEALTH')}>
            <HealthAndSafetyIcon fontSize='small' />
            <Typography>건강</Typography>
          </ToggleButton>
          <ToggleButton value="meal" aria-label="meal" sx={toggleBtn} onClick={() => getCounselList(counselType, 'DIET')}>
            <FlatwareIcon fontSize='small' />
            <Typography>식이</Typography>
          </ToggleButton>

        </ToggleButtonGroup>
      </Stack> */}

      <Box sx={{ mt: 4, width: '80%', mr: 'auto', ml: 'auto', }}>

        {counselList.length <= 0 ? (
          <Box sx={{ textAlign: 'center', mt: 10 }}>
            <SupportAgentIcon sx={{ fontSize: 50, color: '#999' }} />
            <Typography sx={{ fontSize: 16, color: '#777' }}>
              상담 내역이 없습니다.
            </Typography>
          </Box>
        ) : (
          <TableContainer>
            <Table size="small" className="Cl_table">
              <TableHead>
                <TableRow>
                  <TableCell>NO</TableCell>
                  <TableCell>제목</TableCell>
                  <TableCell>작성일</TableCell>
                  <TableCell>답변일</TableCell>
                  <TableCell>상태</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {
                  counselList && counselList.map((item: any, idx: any) => (
                    <TableRow key={cnt} hover={true} onClick={() => { handleSelectRow(item); handleOpen(); }}>
                      <TableCell>{cnt += 1}</TableCell>
                      <TableCell>{item.title}</TableCell>
                      <TableCell>{item.createDate}</TableCell>
                      <TableCell>
                        {
                          item.status ? item.answeredDate : ''
                        }
                      </TableCell>
                      {
                        item.status
                          ? <TableCell sx={{textAlign:'center'}}><Typography  sx={{bgcolor: '#007bff', color: '#fff', borderRadius:20, width: 100, fontSize:14, p:'5px 0px', ml: 'auto', mr: 'auto'}}>답변완료</Typography></TableCell>
                          : <TableCell sx={{textAlign:'center'}}><Typography  sx={{border: '1px solid #007bff', color: '#007bff', borderRadius:20, width: 100, fontSize:14, p:'5px 0px', ml: 'auto', mr: 'auto'}}>답변대기</Typography></TableCell>
                      }
                    </TableRow>
                  ))
                }
              </TableBody>
            </Table>
          </TableContainer>

          // <React.Fragment>
          //   {counselList && counselList.map((item, index) => (
          //     <React.Fragment>
          //       <Accordion sx={{ mb: 2, width: '100%' }}
          //         key={index}
          //         onChange={() => accordionClicked(index)}
          //         expanded={expandedAccordions.includes(index)}>
          //         <AccordionSummary
          //           expandIcon={<ExpandMoreIcon />}
          //           aria-controls="panel1-content"
          //           id="panel1-header"
          //           sx={{
          //             width: '100%',
          //             '& .MuiAccordionSummary-content ': { width: '100%', m: '0 !important' }
          //           }}
          //         >
          //           <Stack direction={'column'} sx={{ width: '100%', p: 2, pl: 0, pr: 0, boxSizing: 'border-box' }}>
          //             <Typography>{getCategoryChipComponent(item.category)}</Typography>
          //             <Stack direction="row" alignItems={'center'} >
          //               <Typography component='div' sx={{ fontSize: 18, mt: 2, mb: 1, fontWeight: 700, color: '#555', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', }}>
          //                 {item.title}
          //               </Typography>
          //               <Typography sx={{ ml: 'auto', mr: 3 }}>
          //                 {util.strNull(item.answerDate) < '1900-01-01' ? (
          //                   <Chip label="답변대기" color="warning" icon={<MoreHorizIcon />} size="small" />
          //                 ) : (
          //                   <Chip label="답변완료" color="success" icon={<CheckIcon />} size="small" />
          //                 )}
          //               </Typography>
          //             </Stack>


          //             <Typography component='div' sx={{ fontSize: 14, color: '#999' }}>{item.createDate.substring(0, 10)}</Typography>

          //           </Stack>
          //         </AccordionSummary>
          //         <AccordionDetails sx={{ pt: 0, }}>

          //           {item.content.split('\n').map((item: any) => (
          //             <Typography sx={{ fontSize: 16, color: '#777', }}>
          //               {item}
          //             </Typography>
          //           ))}
          //           {// 작성자가 동일하고, 답변대기 중인 경우에만 수정할 수 있도록 버튼 제공
          //             util.strNull(item.answerDate) < '1900-01-01' && util.strNull(window.localStorage.userID) === item.memberId ? (
          //               <Button sx={{ display: 'flex', ml: 'auto', p: 0, }} onClick={() => navigate('/check/CreateCounsel', { state: { supportId: item.id } })}>

          //                 <Chip variant="outlined" color="warning" icon={<BorderColorIcon sx={{ fontSize: 16, pl: 1 }} />} label="수정" sx={{ fontSize: 16, fontWeight: 700, }} />
          //               </Button>
          //             ) : (
          //               null
          //             )}
          //         </AccordionDetails>

          //         <AccordionDetails sx={{ p: 2, }}>
          //           <Divider>
          //             <Chip icon={<SupportAgentIcon />} label="답변" sx={{}} />
          //           </Divider>
          //           <Box sx={{ p: 1, pt: 2 }}>
          //             {item.answer.split('\n').map((item: any) => (
          //               <Typography sx={{ fontSize: 16, color: '#777', fontWeight: 700 }}>
          //                 {item}
          //               </Typography>
          //             ))}
          //           </Box>
          //         </AccordionDetails>
          //       </Accordion>

          //     </React.Fragment>
          //   ))}
          // </React.Fragment>
        )}

      </Box>

      {/* <Box sx={{ position: 'fixed', bottom: 60, right: 10, '& > :not(style)': { m: 1, } }}>
        <Fab size="small" color="secondary" aria-label="Creat"
          onClick={() => {
            navigate('/check/CreateCounsel', { state: { supportId: 0 } });
          }}
        >
          <CreateIcon />
        </Fab>
      </Box> */}

      <Grid container className='foot_list'>
        <Pagination
          activePage={counselListParam.pagingNum + 1} // 현재 페이지
          itemsCountPerPage={10} // 한 페이지에 보여줄 아이템 갯수
          totalItemsCount={counselListCount} // 총 아이템 갯수
          pageRangeDisplayed={10} // paginator의 페이지 범위
          prevPageText={"‹"} // "이전"을 나타낼 텍스트
          nextPageText={"›"} // "다음"을 나타낼 텍스트
          onChange={handlePageChange} // 페이지 변경을 핸들링하는 함수
        />
      </Grid>

      {
        <Dialog
          open={open}
          onClose={handleClose}
          aria-describedby="alert-dialog-slide-description"
        >

          <DialogTitle>
            <Stack direction={'row'}>
              <Typography className="wb_title dialogTitle">내 문의 내역</Typography>
              <Typography sx={{ ml: 'auto', color: '#333', fontSize: 20, cursor: 'pointer', pl: 1 }} onClick={handleClose}>X</Typography>
            </Stack>
          </DialogTitle>
          <Divider />

          <DialogContent sx={{ pb: 3, height: '700px', width: '800px' }}>
            <Box>
              <Box className='display_flex alignitem_center'>
                <Typography variant="h3"><FeedbackIcon sx={{ fontSize: 40 }} /></Typography>
                <Typography sx={{ fontSize: 16 }} className="marginleft_10 font_weight">{boardInfo && boardInfo.title}</Typography>
                <Typography sx={{ fontSize: 14 }} className="marginleft_10">{boardInfo && boardInfo.createDate}</Typography>

              </Box>
              {/* <Box sx={{ border: '1px solid #ccc', borderRadius: 5, p: 1, mb: 1.5, boxSizing: 'border-box' }} className="width_500 background_gray">
                <Typography sx={{ fontSize: 16 }} className="marginleft_10 font_weight">{boardInfo && boardInfo.title}</Typography>
              </Box> */}
              <TextField
                className="width_500 background_gray"
                type="text"
                value={boardInfo.question}
                multiline
                InputProps={{
                  readOnly: true,
                }}
                sx={{
                  borderRadius: 5,
                  '& .MuiOutlinedInput-root': { borderRadius: 5 }
                }}
              />
            </Box>

            <Stack alignItems={'flex-end'} sx={{ marginTop: '20px', ml: 'auto' }}>
              <Box className='display_flex alignitem_center '>

                <Box>
                  {/* <Typography className="font_weight" sx={{ fontSize: 16, color: '#444' }}>{boardInfo.helper}</Typography> */}
                  <Typography className="font_weight" sx={{ fontSize: 16, color: '#444' }}>관리자</Typography>
                </Box>
                <Typography variant="h3" className="marginleft_10"><InsertCommentIcon sx={{ fontSize: 40 }} /></Typography>
              </Box>
              <TextField
                type="text"
                name="answer"
                value={boardInfo && boardInfo.answer}
                placeholder="답변 대기 중..."
                multiline
                InputProps={{
                  readOnly: true,
                }}
                className="width_500"
                sx={{
                  borderRadius: 5, bgcolor: '#fffded !important',
                  ml: 7,
                  '& .MuiOutlinedInput-root': { borderRadius: 5 },
                  '& textarea': { bgcolor: '#fffded !important' }
                }}
              />

            </Stack>
          </DialogContent>

          <Divider />

          {
            boardInfo.answer === ''
              ? <DialogActions>
                <Box sx={{ padding: 3, backgroundColor: 'whitesmoke', width: '90%' }}>
                  <Typography>
                    답변이 아직 등록되지 않았습니다. <br />
                    듀얼헬스케어는 신속한 답변을 위해 노력하겠습니다.
                  </Typography>

                  {/* <Button className="btn_cencel" onClick={handleClose}>취소</Button>
  
                {
                  boardInfo.answer === ''
                    ? <Button className="btn_save" onClick={handleBoardUpdate} > 답변등록</Button>
                    : <Button className="btn_save" onClick={handleBoardUpdate} > 답변수정</Button>
                } */}

                </Box>
              </DialogActions>
              : ''
          }

        </Dialog>
      }

      <Bottom />
    </Container>
  );
}

const img = {
  display: 'flex', p: 0, backgroundImage: `url(${tab04})`, backgroundSize: 'cover', mb: 5, borderRadius: 2
}


const toggleBtn = {
  p: 0,
  pt: 1,
  pb: 1,
  flex: '1 1 auto',
  '& .MuiSvgIcon-root': { pl: .3 },
  '& p': { fontSize: 16, p: 0, pl: 1 },
  '&.Mui-selected p': { fontWeight: 700 },
  '&.Mui-selected': {
    backgroundColor: '#0d6703 !important',
    borderColor: '#0d6703',
    boxShadow: 'none',
    color: '#fff'
  },
  '&:hover': {
    backgroundColor: '#074300!important',
    borderColor: '#0d6703',
    boxShadow: 'none',
    color: '#fff'
  },
  '&:active': {
    boxShadow: 'none',
    backgroundColor: '#0d6703!important',
    borderColor: '#0d6703',
    color: " #fff"
  },
  '&:focus': {
    boxShadow: 'none',
    backgroundColor: '#0d6703!important',
    borderColor: '#0d6703',
    color: '#fff'
  },

}

const CareButton = styled(Button)({
  boxShadow: 'none',
  textTransform: 'none',
  fontSize: 16,
  fontWeight: 700,
  padding: '6px 30px',
  lineHeight: 1.5,
  backgroundColor: '#0d6703',
  borderColor: '#0d6703',
  borderRadius: '20px',
  width: '50%',
  '&:hover': {
    backgroundColor: '#0d6703',
    borderColor: '#0d6703',
    boxShadow: 'none',
  },
  '&:active': {
    boxShadow: 'none',
    backgroundColor: '#0d6703',
    borderColor: '#0d6703',
  },
  '&:focus': {
    boxShadow: 'none',
  },
});

export default Counsel;